module.exports = __webpack_public_path__ + "e73b0db2f914825b3bfe2ddae162a735.svg";